// extracted by mini-css-extract-plugin
export var container = "section-header-module--container--o0zLv";
export var divider = "section-header-module--divider--bLnBD elements--divider--9oGzu";
export var header = "section-header-module--header--vGefk type--font-essonnes--k0IEZ type--heading-l--Kf1i8";
export var processHeader = "section-header-module--process-header--Zy2gL type--font-museo--Rt53G";
export var processNumber = "section-header-module--process-number--Z4PK4 type--font-essonnes--k0IEZ type--heading-m--wRwTa";
export var processWrapper = "section-header-module--process-wrapper--QFGo6";